module.exports = __webpack_public_path__ + "img/mongoDB.e56a3ce0.png";